/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Contract,
  ContractFactory,
  ContractTransactionResponse,
  Interface,
} from "ethers";
import type { Signer, ContractDeployTransaction, ContractRunner } from "ethers";
import type { NonPayableOverrides } from "../../../common";
import type {
  MockTopology,
  MockTopologyInterface,
} from "../../../contracts/test/MockTopology";

const _abi = [
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint8",
            name: "parent",
            type: "uint8",
          },
          {
            internalType: "enum AbiType",
            name: "paramType",
            type: "uint8",
          },
          {
            internalType: "enum Operator",
            name: "operator",
            type: "uint8",
          },
          {
            internalType: "bytes",
            name: "compValue",
            type: "bytes",
          },
        ],
        internalType: "struct ConditionFlat[]",
        name: "conditions",
        type: "tuple[]",
      },
    ],
    name: "typeTree",
    outputs: [
      {
        components: [
          {
            internalType: "enum AbiType",
            name: "_type",
            type: "uint8",
          },
          {
            internalType: "uint256[]",
            name: "fields",
            type: "uint256[]",
          },
        ],
        internalType: "struct AbiTypeTree[]",
        name: "result",
        type: "tuple[]",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint8",
            name: "parent",
            type: "uint8",
          },
          {
            internalType: "enum AbiType",
            name: "paramType",
            type: "uint8",
          },
          {
            internalType: "enum Operator",
            name: "operator",
            type: "uint8",
          },
          {
            internalType: "bytes",
            name: "compValue",
            type: "bytes",
          },
        ],
        internalType: "struct ConditionFlat[]",
        name: "conditions",
        type: "tuple[]",
      },
      {
        internalType: "uint256",
        name: "entrypoint",
        type: "uint256",
      },
    ],
    name: "typeTreeAt",
    outputs: [
      {
        components: [
          {
            internalType: "enum AbiType",
            name: "_type",
            type: "uint8",
          },
          {
            internalType: "uint256[]",
            name: "fields",
            type: "uint256[]",
          },
        ],
        internalType: "struct AbiTypeTree[]",
        name: "result",
        type: "tuple[]",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type MockTopologyConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: MockTopologyConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class MockTopology__factory extends ContractFactory {
  constructor(...args: MockTopologyConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override getDeployTransaction(
    overrides?: NonPayableOverrides & { from?: string }
  ): Promise<ContractDeployTransaction> {
    return super.getDeployTransaction(overrides || {});
  }
  override deploy(overrides?: NonPayableOverrides & { from?: string }) {
    return super.deploy(overrides || {}) as Promise<
      MockTopology & {
        deploymentTransaction(): ContractTransactionResponse;
      }
    >;
  }
  override connect(runner: ContractRunner | null): MockTopology__factory {
    return super.connect(runner) as MockTopology__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): MockTopologyInterface {
    return new Interface(_abi) as MockTopologyInterface;
  }
  static connect(
    address: string,
    runner?: ContractRunner | null
  ): MockTopology {
    return new Contract(address, _abi, runner) as unknown as MockTopology;
  }
}
